import { OnInit, Directive, OnDestroy, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from 'app/main/services/cart.service';
import { Subject } from 'rxjs';
import { BaseLanguageLoaderComponent } from './pages/base-language-loader.component';
import { AppService } from './services/app.service';

@Directive()
export class BaseCartDirective extends BaseLanguageLoaderComponent implements OnInit, OnDestroy, AfterViewInit {

	public cartData: any;

	constructor(
		public appService: AppService, 
		public translate: TranslateService, 
		public cartService: CartService){
			super(appService, translate);
		}

	ngOnInit(): void {
		super.ngOnInit();

		// load cart data
		if (this.cartService.cartData.value){
			return this.cartService.cartData.value;
		} else this.cartService.getCart();
	}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

	ngAfterViewInit(): void{
		// sembra non funzionare
		const container = document.querySelector('#container');
		container.scrollTop = container.scrollHeight;
	}
}
